function outletRegistration($rootScope, messageService, merchantService, $location, $uibModal,
                            outletService, utils, systemSettingsService, OutletFormService, $scope,
                            gettextCatalog, appConfig, taxService,
                            merchantUtilService, integrationConstant, _, integrationSettingsService,
                            merchantInfoData, integrationHelperService) {
    const vm = this;
    // new integration settings private function
    const oldIntegrationCode = () => !vm.isCharity();
    const setVisibleFeature = () => {
        vm.visible = {
            isIntegrationSettings: false //oldIntegrationCode()
        };
    };
    // end integration settings private function

    // Var shared with merchant registration
    vm.showOutlet = true;
    vm.country = null;
    vm.showCustomRegionTaxControls = false;
    vm.customRegionTax = OutletFormService.customRegionTax;
    vm.merchantRegionTaxRates = [];
    vm.isDemo = false;

    vm.isCharity = function() {
        return vm.merchant ? merchantUtilService.isCharity(vm.merchant.businessCategory) : false;
    };

    const init = function() {
        OutletFormService.clearOutlet();
        vm.merchant = merchantInfoData;
        vm.loadCountryDetail();
        vm.outlet = OutletFormService.outlet;

        // new integration settings
        vm.location = integrationConstant.LOCATION.outletCreation.label;
        setVisibleFeature();
        // end new integration settings
    };

    // new integration settings, dataOutputConverted is converted to original(back end format)
    vm.mergeToForm = (dataOutputConverted) => {
        const outletMergedValues = _.defaults(dataOutputConverted, vm.outlet);
        vm.outlet = outletMergedValues;
        // need this because is loosing the reference to this old service
        OutletFormService.outlet = vm.outlet;
        // new integration settings
        const flattenData = integrationHelperService.convertServerDataToFlatten(vm.outlet);
        const integrationDetails = integrationSettingsService.integrationDetails(flattenData);
        // same outlet creation rule
        vm.isStoreIdVisible = integrationDetails.isPos && !integrationDetails.isDemo
            && !integrationDetails.isQuadranet;
        // end new integration settings
    };
    // end new integration settings method

    const canShowCustomRegionTaxControls = function(taxEnabled, country) {
        let showCustomRegionTaxControls = false;

        if (taxEnabled) {
            if (country != null) {
                if (country.taxationMerchantRegionOverride != null) {
                    showCustomRegionTaxControls = country.taxationMerchantRegionOverride;
                }
            }
        }

        return showCustomRegionTaxControls;
    };

    const validateCustomRegionTax = function(customRegionTax) {
        if (customRegionTax == null) {
            return false;
        }

        if (utils.hasNoValue(customRegionTax.rate) ||
            utils.hasNoValue(customRegionTax.name) ||
            utils.hasNoValue(customRegionTax.region)) {
            return false;
        }

        if (customRegionTax.exists) {
            return false;
        }

        return true;
    };

    const getCustomRegionTaxForSelectedState = function(selectedState) {
        let customRegionTax = null;

        if (selectedState != null && selectedState != '' && vm.merchantRegionTaxRates != null) {
            for (let i = 0; i < vm.merchantRegionTaxRates.length; i++) {
                const discriminatedTaxRate = vm.merchantRegionTaxRates[i];
                if (selectedState == discriminatedTaxRate.discriminator) {
                    customRegionTax = taxService.convertDiscriminatedTaxRateToCustomRegionTax(discriminatedTaxRate);
                    break;
                }
            }
        }

        if (customRegionTax == null) {
            customRegionTax = OutletFormService.customRegionTax;
            customRegionTax.name = vm.country.defaultSalesTaxName;
            customRegionTax.region = selectedState;
        }

        return customRegionTax;
    };

    const createOutlet = function() {
        outletService.createOutlet(vm.outlet).then(
            (response) => {
                if (vm.showCustomRegionTaxControls && validateCustomRegionTax(vm.customRegionTax)) {
                    // Create tax rate for selected region
                    taxService.createTaxRateForMerchantAndRegion(vm.merchant.id, vm.customRegionTax)
                        .then(() => {
                            $location.path('/merchant/outlets');
                        });
                } else {
                    $location.path('/merchant/outlets');
                }
                // new integration settings
                const flattenData = integrationHelperService.convertServerDataToFlatten(vm.outlet);
                const integrationDetails = integrationSettingsService.integrationDetails(flattenData);
                // old rule, that I don't know why is doing it.
                // !vm.isDemo && (vm.outlet.payAtTableOverride || vm.merchant.options.payAtTable)
                if (integrationDetails.isPayAtTable && !vm.isDemo) {
                    outletService.linkShareMenuForPos(response.data.id);
                }
            },
            (reason) => {
                messageService.errorWithReason(reason, null, false);
            }
        );

    };

    $scope.$watch('vm.outlet.addressLine1', (newVal, oldVal) => {
        if (newVal !== oldVal) {
            // Get the child, probably this is going to change when take from the modal
            // Var createForm = $scope.$$childTail.createForm


            if ($scope.createForm.outletName) {
                // This set the fiedl to $dirty true
                $scope.createForm.outletName.$setViewValue($scope.createForm.outletName.$viewValue);
                vm.outlet.name = OutletFormService.changeName();
            }
        }
    });

    vm.cancel = function() {
        $location.path('/merchant/outlets');
    };

    vm.saveOutlet = function(createForm) {

        if (createForm.$invalid) {
            return createForm.$invalid;
        }

        if (vm.selectStateObj) {
            vm.outlet.state = vm.selectStateObj.name;
        }

        // TODO there is not localtion for charity, it should not show the modal to biz charity
        outletService.getTimeZoneIdGoogle(vm.outlet.latitude, vm.outlet.longitude).then(
            (response) => {
                if (response.data && response.data.value) {
                    vm.outlet.timezoneId = response.data.value;
                    createOutlet();
                }
                else {
                    // If google timezone API cannot resolve timezone, select it from a list within a modal.
                    if (utils.hasNoValue(vm.merchant.contactDetails.country)) {
                        messageService.error(gettextCatalog
                            .getString('No country information found for this merchant'));
                    }
                    else {
                        const timezoneModalInstance = $uibModal.open({
                            template: require('../../templates/timezone/timezone.html'),
                            controller: 'TimezoneController as timezoneCtrl',
                            windowClass: 'modal-small',
                            backdrop: 'static',
                            resolve: {
                                timezones() {
                                    return vm.merchant.contactDetails.country.timezones;
                                }
                            }
                        });

                        timezoneModalInstance.result.then((result) => {
                            if (result !== 'cancel') {
                                vm.outlet.timezoneId = result;
                                createOutlet();
                            }
                        }, () => {
                        });
                    }
                }
            }, (reason) => {
                // If google timezone API cannot resolve timezone, select it from a list within a modal.
                if (utils.hasNoValue(vm.merchant.contactDetails.country)) {
                    messageService.error(gettextCatalog
                        .getString('No country information found for this merchant'));
                    return;
                }

                const timezoneModalInstance = $uibModal.open({
                    template: require('../../templates/timezone/timezone.html'),
                    controller: 'TimezoneController as timezoneCtrl',
                    windowClass: 'modal-small',
                    backdrop: 'static',
                    resolve: {
                        timezones() {
                            return vm.merchant.contactDetails.country.timezones;
                        }
                    }
                });

                timezoneModalInstance.result.then((result) => {
                    if (result !== 'cancel') {
                        vm.outlet.timezoneId = result;
                        createOutlet();
                    }
                }, () => {
                });
            }
        );
    };

    vm.loadCountryDetail = function() {
        const localMsg = gettextCatalog.getString('State/County');

        if (!vm.merchant.contactDetails || !vm.merchant.contactDetails.country) {
            vm.stateDisplayName = localMsg;
            return;
        }

        const countryId = vm.merchant.contactDetails.country.id;

        systemSettingsService.loadCountry(countryId).then(

            (response) => {
                vm.country = response;
                vm.stateDisplayName = vm.country.stateDisplayName;

                if (utils.hasNoValue(vm.stateDisplayName)) {
                    vm.stateDisplayName = localMsg;
                }

                vm.stateSelectableValues = vm.country.stateSelectableValues;
                vm.showCustomRegionTaxControls =
                        canShowCustomRegionTaxControls(vm.merchant.taxCalculationsEnabled, vm.country);

                if (vm.showCustomRegionTaxControls) {
                    vm.customRegionTax.name = vm.country.defaultSalesTaxName;

                    taxService.getTaxRatesForMerchantAndRegion().then((merchantRegionTaxRates) => {
                            vm.merchantRegionTaxRates = merchantRegionTaxRates;
                        }
                    );
                }
            },
            (reason) => {
                messageService.error('Error to load the country detail', reason);
            }
        );
    };

    vm.stateChanged = function() {
        if (vm.showCustomRegionTaxControls && vm.selectStateObj != null && vm.selectStateObj != '') {
            vm.customRegionTax = getCustomRegionTaxForSelectedState(vm.selectStateObj.name);
        }
    };

    vm.showFeatures = function() {
        return merchantService.behaviour($rootScope.merchantInfo, 'outletsPage.showMultiFeatures');
    };

    // **** Original rule ****
    // Disabling these function because it looks like its an old rule that was to avoid schools to create
    // a second outlet, but we hide the button(that links to this page) to create an outlet
    // instead of disable the button here
    // vm.disableSaveButton = function() {
    // return (!(vm.outlet.orderAheadOverride ||
    // vm.outlet.barTabOverride ||
    // vm.outlet.payAtTableOverride ||
    // vm.isCharity()));
    //};

    init();
}
/* eslint max-statements:0 */
angular.module('qkr').controller('OutletRegistration', outletRegistration);


// WEBPACK FOOTER //
// ./src/controllers/merchant/outlet.registration.controller.js